import React, { Component } from "react";
import performRequest from "network/perform-request";
import {
  competitionsShowRoute,
  competitionEstablishmentsAddRoute,
  competitionEstablishmentsDeleteRoute,
  competitionTournamentVenuesRoute,
  competitionTournamentVenueRoute,
} from "network/api-routes";
import {
  Button,
  Card,
  CircularProgress,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  CardMedia,
  CardContent,
  CardActions,
  Box,
  Grid2,
  Stack,
} from "@mui/material";
import { withStyles } from "@mui/styles";
import "moment/locale/es";
import AlertDialog from "../../common/AlertDialog";
import { Autocomplete } from "@mui/material";
import RevaText from "components/common/RevaText";
import { injectIntl } from "react-intl";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import VenueFormDialog from "components/venues/VenueFormDialog";
import { availableVenueOptions } from "components/pages/Competition/competition-venues";

const styles = (theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
  },
  createButton: {
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(8),
    fontSize: 20,
    fontWeight: 600,
    textTransform: "none",
  },
});

class CompetitionEstablishments extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id,
      ready: false,
      users: [],
      openModal: false,
      deleteOpen: false,
      establishmentOptions: [],
      selectedEstablishment: null,
      toDeleteEstablishment: null,
      createOpen: false,
      editingVenue: null,
      creating: false,
    };
    this.handleClose = this.handleClose.bind(this);
    this.submit = this.submit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.delete = this.delete.bind(this);
    this.createVenue = this.createVenue.bind(this);
  }

  componentDidMount() {
    this.fetch();
    this.fetchUserEstablishments();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.reloadKey !== this.props.reloadKey) {
      this.fetch();
      this.fetchUserEstablishments();
    }
  }

  fetch() {
    const { user } = this.props.userContext;

    performRequest("POST", competitionsShowRoute, { competition_uuid: this.state.id }, true, user)
      .then((response) => {
        const competition = response.data.data;
        this.setState({
          competition,
          establishments: competition.establishments?.data ?? [],
          ready: true,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  fetchUserEstablishments() {
    const { user } = this.props.userContext;

    performRequest("GET", competitionTournamentVenuesRoute, {}, true, user)
      .then((response) => {
        const establishmentOptions = Array.isArray(response.data) ? response.data : [];
        this.setState({ establishmentOptions });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  reset() {
    this.setState({
      selectedEstablishment: null,
      toDeleteEstablishment: null,
    });
  }

  submit() {
    if (!this.state.selectedEstablishment) return;
    const { user } = this.props.userContext;
    this.handleClose();
    this.setState({ ready: false }, () => {
      performRequest(
        "POST",
        competitionEstablishmentsAddRoute,
        {
          competition_uuid: this.state.id,
          tournament_venue_id: this.state.selectedEstablishment.id,
          establishment_id: this.state.selectedEstablishment.source_establishment_id || undefined,
        },
        true,
        user
      )
        .then((response) => {
          this.reset();

          this.fetch();
        })
        .catch((error) => {
          this.reset();
          this.fetch();
        });
    });
  }

  handleClose() {
    this.setState({ openModal: false });
  }

  createVenue(formData) {
    const { user } = this.props.userContext;
    const editingVenue = this.state.editingVenue;
    formData.append("competition_uuid", this.state.id);

    this.setState({ creating: true });
    const route = editingVenue
      ? competitionTournamentVenueRoute(editingVenue.tournament_venue_id || editingVenue.id)
      : competitionTournamentVenuesRoute;
    performRequest("POST", route, formData, true, user)
      .then(() => {
        this.setState({ createOpen: false, creating: false, openModal: false, editingVenue: null });
        this.fetch();
        this.fetchUserEstablishments();
      })
      .catch(() => {
        this.setState({ creating: false });
        this.fetch();
      });
  }

  handleChange = (name) => (event) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  renderAddDialog() {
    const { intl } = this.props;

    return (
      <Box>
        <Dialog open={this.state.openModal} onClose={this.handleClose} fullWidth>
          <DialogTitle>{intl.formatMessage({ id: "Agregar un club" })}</DialogTitle>
          <DialogContent>
            <Autocomplete
              disableCloseOnSelect={false}
              multiple={false}
              value={this.state.selectedEstablishment}
              options={availableVenueOptions(this.state.establishmentOptions, this.state.establishments)}
              renderOption={(props, option) => (
                <li {...props} key={option.id}>
                  {option.public_name || option.name}
                  {option.address ? ` — ${option.address}` : ""}
                  {option.bookable ? "" : " (sede)"}
                </li>
              )}
              getOptionLabel={(option) => option.public_name || option.name || ""}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              onChange={(event, value) => {
                this.setState({
                  selectedEstablishment: value,
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={intl.formatMessage({ id: "competition.venues.pick" })}
                  variant="outlined"
                />
              )}
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() =>
                this.setState({
                  createOpen: true,
                  editingVenue: null,
                })
              }
            >
              {intl.formatMessage({ id: "competition.venues.create" })}
            </Button>
            <Button onClick={this.handleClose}>{intl.formatMessage({ id: "Cancelar" })}</Button>
            <Button onClick={this.submit}>{intl.formatMessage({ id: "Agregar" })}</Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }

  renderCreateDialog() {
    const { intl } = this.props;
    const editing = this.state.editingVenue;

    return (
      <VenueFormDialog
        open={!!this.state.createOpen}
        venue={editing}
        saving={this.state.creating}
        title={intl.formatMessage({ id: editing ? "gestion.venues.edit" : "competition.venues.create" })}
        onClose={() => this.setState({ createOpen: false, editingVenue: null })}
        onSubmit={(formData) => this.createVenue(formData)}
      />
    );
  }

  delete() {
    const { user } = this.props.userContext;
    this.handleClose();
    this.setState({ ready: false }, () => {
      performRequest(
        "POST",
        competitionEstablishmentsDeleteRoute,
        {
          competition_uuid: this.state.id,
          tournament_venue_id: this.state.toDeleteEstablishment.tournament_venue_id || this.state.toDeleteEstablishment.id,
          establishment_id: this.state.toDeleteEstablishment.bookable
            ? this.state.toDeleteEstablishment.establishment_id
            : undefined,
        },
        true,
        user
      )
        .then((response) => {
          this.setState(
            {
              selectedUserInvite: null,
              ready: false,
            },
            () => {
              this.fetch();
            }
          );
        })
        .catch((error) => {
          this.fetch();
        });
    });
  }
  renderConfirmDeleteDialog() {
    return (
      <AlertDialog
        hideButton
        isOpen={this.state.deleteOpen}
        onConfirm={() => this.setState({ deleteOpen: false }, this.delete)}
        onCancel={() => this.setState({ deleteOpen: false })}
        alertBody="¿Estás seguro que quieres remover este local? Esto no modificará los partidos que ya tengan espacios asignados"
        confirmButtonTitle="Si, estoy seguro"
        cancelButtonTitle="Volver atrás"
      />
    );
  }

  render() {
    const { intl } = this.props;

    if (!this.state.ready) {
      return (
        <Grid item container justifyContent="center" style={{ marginTop: 30 }}>
          <CircularProgress size={24}></CircularProgress>
        </Grid>
      );
    }

    return (
      <>
        <Stack spacing={2}>
          {!this.props.hideTitle ? <RevaText id="Locales" variant="h2" /> : (
            <RevaText variant="h6">{intl.formatMessage({ id: "gestion.venues.localesSection" })}</RevaText>
          )}
          <RevaText
            id={this.props.hideTitle ? "gestion.venues.localesHint" : "Agrega locales a tu evento para utilizar sus canchas en tus partidos."}
            variant="body1"
          />
          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, sm: 6, lg: 4 }}>
              <Button
                color="secondary"
                sx={{
                  borderStyle: "dashed",
                  borderWidth: 2,
                  width: "100%",
                  height: "100%",
                  minHeight: 200,
                  flex: 1,
                  flexDirection: "column",
                }}
                onClick={() => this.setState({ openModal: true })}
              >
                <AddCircleOutlineIcon fontSize="large" sx={{ mb: 2 }} />
                <RevaText variant="h4">{intl.formatMessage({ id: "Agregar club" })}</RevaText>
              </Button>
            </Grid2>
            {this.state.establishments.map((establishment) => (
              <Grid2 size={{ xs: 12, sm: 6, lg: 4 }} key={establishment.id}>
                <Card>
                  <CardMedia
                    component="img"
                    height="140"
                    image={establishment.full_banner_url || "/placeholder.png"}
                    alt={establishment.public_name || establishment.name}
                  />
                  <CardContent sx={{ height: "max-content" }}>
                    <RevaText gutterBottom variant="h4" component="div">
                      {establishment.public_name || establishment.name}
                    </RevaText>
                    <RevaText variant="caption">{establishment.address}</RevaText>
                  </CardContent>
                  <CardActions>
                    {establishment.can_edit && (
                      <Button
                        onClick={() =>
                          this.setState({
                            editingVenue: establishment,
                            createOpen: true,
                          })
                        }
                      >
                        {intl.formatMessage({ id: "gestion.venues.edit" })}
                      </Button>
                    )}
                    <Button
                      onClick={() =>
                        this.setState({
                          toDeleteEstablishment: establishment,
                          deleteOpen: true,
                        })
                      }
                    >
                      {intl.formatMessage({ id: "Remover" })}
                    </Button>
                  </CardActions>
                </Card>
              </Grid2>
            ))}
          </Grid2>
        </Stack>
        {this.renderConfirmDeleteDialog()}
        {this.renderAddDialog()}
        {this.renderCreateDialog()}
      </>
    );
  }
}

export default withStyles(styles)(injectIntl(CompetitionEstablishments));
